/**
 * @generated SignedSource<<ed602b8309e4c6b80d87ca187403028e>>
 * @relayHash 479cc21a1fb5fc53e2a65af4221b3eaa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 582b608f854de79f12d4546eb7b8b8b95988dbb5dc489a6d1b38191927fe334e

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdatesOld_issueUpdatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueUpdatedSubscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueUpdatedSubscription = {
  response: IssueRealtimeUpdatesOld_issueUpdatedSubscription$data;
  variables: IssueRealtimeUpdatesOld_issueUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "582b608f854de79f12d4546eb7b8b8b95988dbb5dc489a6d1b38191927fe334e",
    "metadata": {},
    "name": "IssueRealtimeUpdatesOld_issueUpdatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "e282e82465724e5d7819eb55e1da2e50";

export default node;
